export function downloadInboxVcard(email) {
  const vcf = [
    "BEGIN:VCARD", "VERSION:3.0",
    "N:Postvak;Praktisch-Debiteurenbeheer;;;",
    "FN:Postvak Praktisch-Debiteurenbeheer",
    "ORG:Praktisch-Debiteurenbeheer",
    `EMAIL;TYPE=INTERNET,PREF:${email}`,
    "NOTE:Stuur e-mails van debiteuren door naar dit adres; ze verschijnen in het Postvak.",
    "END:VCARD",
  ].join("\r\n");
  const url = URL.createObjectURL(new Blob([vcf], { type: "text/vcard;charset=utf-8" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = "Postvak-Praktisch-Debiteurenbeheer.vcf";
  a.click();
  URL.revokeObjectURL(url);
}
